<template>
   <div class="home">
    <div id="carousel-container">
      <v-carousel
      :height="carouselHeight"
      cycle
      interval=5000
      show-arrows-on-hover>

        <v-carousel-item :src="require('../assets/images/images1.jpeg')">
          <figure align="center" class="slide center col-lg-5 col-9">Find the best rental solutions all in one place</figure>
        </v-carousel-item>

        <v-carousel-item :src="require('../assets/images/images2.jpg')">
          <figure align="center" class="slide center col-lg-5 col-9">Advertise and search for the best rental deals ever</figure>
        </v-carousel-item>

        <v-carousel-item :src="require('../assets/images/images3.jpg')">
          <figure align="center" class="slide center col-lg-5 col-9">Get fast and easy access to the services you need</figure>
        </v-carousel-item>

        <v-carousel-item :src="require('../assets/images/images4.jpeg')">
          <figure align="center" class="slide center col-lg-5 col-9">We offer 100% fraud protection on all your rentals</figure>
        </v-carousel-item>
      </v-carousel>

    <div id="carousel-container-shadow" class="relative"></div>
    </div>

    <user-category />

  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',

  data: () => ({
    source: null
  }),

  computed: {
    mobile () {
      let value
      window.innerWidth <= 760
      ? value = true
      : value = false

      return value
    },

    carouselHeight () {
      let value = 0.65 * window.innerHeight

      return value
    }
  },

   methods: {
    showUserType (token) {
      if (token === 'broker') {
        this.isBroker = true
        this.isClient = false
      } else if (token === 'client') {
        this.isClient = true
        this.isBroker = false
      }
    }
  }
}
</script>

<style scoped>
/* MOBILE */
@media screen and (max-width: 1023px) {
  #carousel-container-shadow {
    box-shadow: inset -0.5px 5px 10px 3px var(--deepblue) !important;
  }

  figure.slide {
    margin-top: 12rem !important;
  }
}

#carousel-container {
  height: 55vh;
  border-radius: 0px 0px 1.5rem 1.5rem;
  overflow: hidden;
}

#carousel-container-shadow {
  height: 55vh;
  top: -65vh;
  border-radius: 0px 0px 1.5rem 1.5rem;
  box-shadow: inset -0.5px 5px 10px 2px var(--deepblue);
}

figure.slide {
  font-size: 1.5rem;
  padding: 1rem;
  margin-top: 17rem;
  border-radius: 0.5rem;
  color: var(--powderblue);
  background: rgba(0,0,0,0.75);
}
</style>
